import {
    AfterViewInit, Component, EventEmitter, Input,
    Output
} from '@angular/core';
import { AddressModel } from '../../../../shared/models/address.model';
import { DeliveryStepsService } from '../../../services/delivery-steps.service';

@Component({
    selector: 'payment-delivery-addresses-address-item',
    templateUrl: './payment.delivery.addresses.address-item.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentDeliveryAddressesAddressItemComponent {
    @Input('checked') checked = false;
    @Input('address') address: AddressModel;
    @Input('updatable') updatable = false;
    @Output() selected: EventEmitter<AddressModel> = new EventEmitter();
    @Output() requestedUpdate: EventEmitter<AddressModel> = new EventEmitter();

    /**
     * This trigger an update request to parent component.
     **/
    public updateSelectedAddressInfo(): void {
        this.requestedUpdate.emit(this.address);
    }

    /**
     * Register selected address and trigger selectAddress event.
     **/
    public selectAddress() {
        this.selected.emit(this.address);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/delivery/addresses/address-item/payment.delivery.addresses.address-item.component.ts